<template>
  <DialogPopup
    ref="dialog"
    v-show="isOpened"
    :title="$t('planUpgrade.dialogTitle')"
    :prevButtonTitle="$t('planUpgrade.navCancel')"
    :nextButtonTitle="$t('planUpgrade.navNext')"
    :isOpened="isOpened"
    :progress="progress"
    :progressScenarioId="progressScenarioId"
    :v-slot="{activePageId: activePageId}"
    :activePageId="activePageId"
    v-on:DialogClose="handleDialogClose"
    v-on:PageChange="handlePageChange"
    :class="[{'opacity-0': isDatatransDialogOpen}]">

    <DialogPopupPage
      progressScenarioId="UPGRADE"
      :default="!hasPayment"
      :navigationNext="$t('planUpgrade.navNext')"
      :onNext="handlers.submitOverviewForm"
      :pageId="steps.STEP_OVERVIEW"
      :showPrevButton="true"
      :showNextButton="true"
      :navigationPrev="$t('planUpgrade.close')"
      :nextPage="nextPage(steps.STEP_BILLING_DETAILS)"
      v-show="activePageId === steps.STEP_OVERVIEW">
      <PlanUpgradeOverview
        ref="overview"
        :billingDetails="billingDetails"
        :payment="payment"
        :nextPage="steps.STEP_BILLING_DETAILS"
        :isActive="(!activePageId || activePageId === steps.STEP_OVERVIEW) && isOpened"/>
    </DialogPopupPage>

    <DialogPopupPage
      :onNext="performSubmitBillingDetails"
      :onPrev="handleBackButton(steps.STEP_BILLING_DETAILS)"
      :pageId="steps.STEP_BILLING_DETAILS"
      :navigationBack="$t('planUpgrade.navPrev')"
      :showPrevButton="true"
      :showNextButton="true"
      :navigationNext="$t('planUpgrade.navNext')"
      :navigationPrev="$t('planUpgrade.navPrev')"
      v-show="activePageId === steps.STEP_BILLING_DETAILS">
      <PlanUpgradeBillingDetails
        ref="billingDetails"
        :nextPage="steps.STEP_PAYMENT"
        :isActive="(!activePageId || activePageId === steps.STEP_BILLING_DETAILS) && isOpened"
        :billingDetails="billingDetails"/>
    </DialogPopupPage>

    <DialogPopupPage
      :default="hasPayment"
      :onNext="handlers.handlePaymentForm"
      :onPrev="handleBackButton(steps.STEP_PAYMENT)"
      :onFail="handlers.handlePaymentForm"
      :pageId="steps.STEP_PAYMENT"
      :showNextButton="isPaymentNextButtonVisible"
      :showPrevButton="isPaymentFailedButtonVisible"
      :showFailButton="isPaymentFailedButtonVisible"
      :nextPage="nextPage(steps.STEP_PAYMENT)"
      :navigationNext="paymentNextButtonTitle"
      :navigationPrev="paymentPrevButtonTitle"
      :navigationFail="paymentFailButtonTitle"
      v-show="activePageId === steps.STEP_PAYMENT">
      <Payment
        :onNext="handlers.handleUserSession"
        ref="payment"
        :isActive="(!activePageId || activePageId === steps.STEP_PAYMENT) && isOpened"
        :billingDetails="billingDetails"
        :payment="payment"/>
    </DialogPopupPage>
  </DialogPopup>
</template>

<script src="./plan-upgrade.js"></script>
<style lang="scss" src="./plan-upgrade.scss"></style>
